import { render, staticRenderFns } from "./DragDialog.vue?vue&type=template&id=56bfbd16"
import script from "./DragDialog.vue?vue&type=script&lang=js"
export * from "./DragDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports